import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import { CategoryLandingPageSubcategoriesSection, CategoryWithThumbnail, ImageTransformation } from '@services';
import styles from '../CategoryLandingPage.module.scss';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import Link from 'next/link';
import { ROUTES } from '@constants';

const CN = 'category-landing-page';
const sectionClassName = `${CN}__section`;
const subcategoryListClassName = `${sectionClassName}__subcategory-list`;
const subcategoryClassName = `${subcategoryListClassName}__subcategory`;
const sectionTitleClassName = `${sectionClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  section: CategoryLandingPageSubcategoriesSection;
  subcategories: CategoryWithThumbnail[]
}

export const Subcategories: React.FC<Props> = ({
  section: {
    subcategories: {
      title
    }
  },
  subcategories
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(sectionClassName) }>
      <Typography className={ cx(sectionTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <div className={ cx(subcategoryListClassName) }>
        {subcategories.map(subcategory => (
          <Link href={ `${ROUTES.catalog}/${subcategory.key}` } key={ subcategory.id } >
            <div className={ cx(subcategoryClassName) }>
              <img
                key={ subcategory.thumbnail?.public_id }
                src={ imageTransformation.transformById(
                  subcategory.thumbnail?.public_id,
                  ALL_IMAGES_TRANSFORMATIONS
                ) }
              />
              <Typography className={ cx(sectionTitleClassName) }>
                {subcategory.name}
              </Typography>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
